import firebase from 'firebase';

const firebaseConfig = {
	apiKey: 'AIzaSyAKqxUouI3DVSa6__BOjM9lgiqATl5JYEY',
	authDomain: 'facebook-clone-ddd04.firebaseapp.com',
	databaseURL: 'https://facebook-clone-ddd04.firebaseio.com',
	projectId: 'facebook-clone-ddd04',
	storageBucket: 'facebook-clone-ddd04.appspot.com',
	messagingSenderId: '1050286032984',
	appId: '1:1050286032984:web:3fbbd94756ba2d4934a22d',
	measurementId: 'G-RKZN1KEFD6',
};

// connect react frontend to backend firebase

const firebaseApp = firebase.initializeApp(firebaseConfig);

const db = firebaseApp.firestore();
const auth = firebase.auth();
const provider = new firebase.auth.GoogleAuthProvider();

export { auth, provider };
export default db;
